import './index.css';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var styles = {"vertical":"magritte-vertical___pLcci_1-1-45","horizontal":"magritte-horizontal___WHVm-_1-1-45"};

const genLengthStyles = (mode, length) => {
    if (!length) {
        return {};
    }
    if (mode === 'vertical') {
        return {
            height: `${length}px`,
        };
    }
    return {
        width: `${length}px`,
    };
};
const Divider = ({ mode = 'horizontal', marginTop = 0, marginRight = 0, marginLeft = 0, marginBottom = 0, length, }) => {
    return (jsx("div", { className: classNames({
            [styles.horizontal]: mode === 'horizontal',
            [styles.vertical]: mode === 'vertical',
        }), style: {
            ...genLengthStyles(mode, length),
            margin: `${marginTop}px ${marginRight}px ${marginBottom}px ${marginLeft}px`,
        }, role: "separator", "aria-orientation": mode }));
};

export { Divider };
//# sourceMappingURL=Divider.js.map
